import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const WishlistContext = createContext(null);

export const WishlistProvider = ({ children }) => {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);
  const [products, setProducts] = useState([]);

  const refresh = useCallback(async () => {
    if (!user) {
      setIds([]); setProducts([]);
      return;
    }
    const res = await api.get("/wishlist");
    setIds(res.data.product_ids || []);
    setProducts(res.data.products || []);
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const toggle = async (product_id) => {
    if (!user) throw new Error("Please sign in");
    if (ids.includes(product_id)) {
      await api.delete(`/wishlist/${product_id}`);
    } else {
      await api.post(`/wishlist/${product_id}`);
    }
    await refresh();
  };

  const isInWishlist = (id) => ids.includes(id);

  const value = useMemo(
    () => ({ ids, products, toggle, isInWishlist, refresh, count: ids.length }),
    [ids, products, refresh]
  );

  return (
    <WishlistContext.Provider value={value}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
